import React, { useEffect, useState, useRef, createElement } from 'react';
import { LayoutDashboardIcon, PencilRulerIcon, DollarSignIcon, ShoppingCartIcon, UsersIcon, BadgeIcon, WarehouseIcon, HeadphonesIcon, SettingsIcon, UserIcon, LogOutIcon, BarChart3Icon, HomeIcon, ChevronLeftIcon, ChevronRightIcon, PencilIcon, GlobeIcon, RulerIcon, CheckIcon, ChevronUpIcon, BuildingIcon, XIcon, SparklesIcon, WrenchIcon, BugIcon, HeartIcon } from 'lucide-react';
import { EditProfileModal } from './EditProfileModal';
import { EditCompanyModal } from './EditCompanyModal';
import { useUser } from '../contexts/UserContext';
const languages = [{
  code: 'en',
  name: 'English',
  flag: '🇺🇸'
}, {
  code: 'es',
  name: 'Español',
  flag: '🇪🇸'
}, {
  code: 'fr',
  name: 'Français',
  flag: '🇫🇷'
}, {
  code: 'de',
  name: 'Deutsch',
  flag: '🇩🇪'
}, {
  code: 'pt',
  name: 'Português',
  flag: '🇵🇹'
}];
const unitSystems = [{
  id: 'metric',
  name: 'Métrico',
  description: 'km, kg, °C'
}, {
  id: 'imperial',
  name: 'Imperial',
  description: 'mi, lb, °F'
}];
export function Sidebar({
  onNavigate,
  activePage = 'home',
  collapsed = false,
  onToggleSidebar
}) {
  const [changelogOpen, setChangelogOpen] = useState(false);
  const toggleSidebar = () => {
    if (onToggleSidebar) {
      onToggleSidebar();
    }
  };
  return <div className={`${collapsed ? 'w-[72px]' : 'w-[208px]'} bg-gradient-to-b from-blue-950 to-teal-900 text-white flex flex-col h-screen sticky top-0 left-0 transition-all duration-300 ease-in-out relative group overflow-visible z-50`} data-id="element-6358" data-mp="1gzsvlbwj1hm2">
      <div className="p-5 flex flex-col items-center pt-[20px] pb-[0px] pl-[20px] pr-[20px]" data-id="element-6359" data-mp="29oghn9p3ob0o">
        <div className="flex items-center" data-id="element-6360" data-mp="1vp74kiw6xx0x">
          {collapsed ? <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cZrMyYGysL7x2nzbnxUSuo/White_Drop_for_Whatsapp.png" alt="Aisco Logo" className="h-7 w-auto transition-all duration-300" data-id="element-6361" data-mp="20ns5kkj9okqf" /> : <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j7rsd4nQRUtzsXBFyA8c5B/AISCO_WORKSPACE_MARCA_NEGATIVO.svg" alt="Aisco Logo" className="h-9 w-auto filter brightness-0 invert transition-all duration-300" data-id="element-6362" data-mp="p94v822ogg9g" />}
        </div>
        <button onClick={() => setChangelogOpen(true)} className="mt-0.5 text-blue-300/60 hover:text-blue-200 transition-colors cursor-pointer text-[12px]" title="View changelog" data-id="element-6363" data-mp="2m0sdys7vokwy">
          {collapsed ? 'v3.1' : 'v3.1.0'}
        </button>
      </div>
      <nav className="flex-1 px-3 py-4 overflow-y-auto no-scrollbar" data-id="element-6364" data-mp="2882scow9hi0d">
        <SidebarItem icon={<HomeIcon size={20} data-id="element-6366" data-mp="285q11l4m5van" />} label="Inicio" active={activePage === 'home'} onClick={() => onNavigate('home')} collapsed={collapsed} data-id="element-6365" data-mp="289duyldz0jpw" />
        <SidebarItem icon={<LayoutDashboardIcon size={20} data-id="element-6368" data-mp="1yao9kimv8h4w" />} label="Dashboard" active={activePage === 'dashboard'} onClick={() => onNavigate('dashboard')} collapsed={collapsed} data-id="element-6367" data-mp="1y94ugvcy4c4p" />
        <SidebarItem icon={<PencilRulerIcon size={20} data-id="element-6370" data-mp="3so7ewen5140r" />} label="Design" active={activePage === 'design'} onClick={() => onNavigate('design')} collapsed={collapsed} data-id="element-6369" data-mp="3snnumra0m3jk" />
        <SidebarItem icon={<DollarSignIcon size={20} data-id="element-6372" data-mp="1aekyztv3dzkf" />} label="Quotes" active={activePage === 'quotes'} onClick={() => onNavigate('quotes')} collapsed={collapsed} data-id="element-6371" data-mp="3ok80q2pbyhak" />
        <SidebarItem icon={<DollarSignIcon size={20} data-id="element-6374" data-mp="1fc375i1acard" />} label="Quotes V2" active={activePage === 'quotes-v2'} onClick={() => onNavigate('quotes-v2')} collapsed={collapsed} data-id="element-6373" data-mp="1fcmjmj8626y0" />
        <SidebarItem icon={<DollarSignIcon size={20} data-id="element-6376" data-mp="1o4wtu0j2acf9" />} label="Quotes V3" active={activePage === 'quotes-v3'} onClick={() => onNavigate('quotes-v3')} collapsed={collapsed} data-id="element-6375" data-mp="1o6hl9ha2xf8w" />
        <SidebarItem icon={<DollarSignIcon size={20} data-id="element-6378" data-mp="wea6kme4wcx5" />} label="Quote V4" active={activePage === 'quotes-v4'} onClick={() => onNavigate('quotes-v4')} collapsed={collapsed} data-id="element-6377" data-mp="wesbe7ev3zgo" />
        <SidebarItem icon={<ShoppingCartIcon size={20} data-id="element-6380" data-mp="10iq9qfwd568o" />} label="Order" active={activePage === 'order'} onClick={() => onNavigate('order')} collapsed={collapsed} data-id="element-6379" data-mp="10f2hdk2nmpvj" />
        <SidebarItem icon={<UsersIcon size={20} data-id="element-6382" data-mp="2bv0vw3glq445" />} label="Dealers" active={activePage === 'dealers'} onClick={() => onNavigate('dealers')} collapsed={collapsed} data-id="element-6381" data-mp="2buir2ifvihkm" />
        <SidebarItem icon={<BadgeIcon size={20} data-id="element-6384" data-mp="2fcycxjeun3hb" />} label="Subscription" active={activePage === 'subscription'} onClick={() => onNavigate('subscription')} collapsed={collapsed} data-id="element-6383" data-mp="2fdgjb8v86y2y" />
        <SidebarItem icon={<WarehouseIcon size={20} data-id="element-6386" data-mp="2oe6au0dge2av" />} label="Warehouses" active={activePage === 'warehouses'} onClick={() => onNavigate('warehouses')} collapsed={collapsed} data-id="element-6385" data-mp="2aghriwz1b37x" />
        <SidebarItem icon={<HeadphonesIcon size={20} data-id="element-6388" data-mp="2kenr37xdbx9m" />} label="Customer support" active={activePage === 'support'} onClick={() => onNavigate('support')} collapsed={collapsed} data-id="element-6387" data-mp="2kazwe5g6t4tb" />
        {/* New Business Intelligence (empty, for redesign) */}
        <SidebarItem icon={<BarChart3Icon size={20} data-id="element-6390" data-mp="382ndjvnnd1ie" />} label="Business Intelligence" active={activePage === 'business-intelligence-v2'} onClick={() => onNavigate('business-intelligence-v2')} collapsed={collapsed} data-id="element-6389" data-mp="3825iv3gmuvcl" />
        {/* BI v1 with cyborg icon and special styling */}
        <div className={`flex items-center px-3 py-2 my-1 rounded cursor-pointer transition-colors relative
            bg-gradient-to-r from-purple-600 to-blue-600 shadow-lg
            ${collapsed ? 'justify-center' : ''}
            animate-pulse
          `} onClick={() => onNavigate('business-intelligence')} title={collapsed ? 'BI v1' : ''} data-id="element-6391" data-mp="3h0r270txieef">
          <div className={`${collapsed ? '' : 'mr-3'} text-white flex-shrink-0 relative`} data-id="element-6392" data-mp="3mpm1vhr7jfsw">
            <div className="absolute inset-0 bg-gradient-to-b from-blue-950 to-teal-900 opacity-0 rounded-full" data-id="element-6393" data-mp="3qpwhzn8prmlh"></div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eJcyBj2puhjmA95iiZVfaB/cyborg.svg" alt="BI v1" className="w-5 h-5 filter brightness-0 invert relative z-10" data-id="element-6394" data-mp="3cxzujwhzq0vf" />
          </div>
          {!collapsed && <span className="text-sm font-bold text-white pr-2 leading-tight" data-id="element-6395" data-mp="3326e4215hn8d">
              BI v1
            </span>}
        </div>
        <SidebarItem icon={<PencilRulerIcon size={20} data-id="element-6397" data-mp="2u06vx6eegd3u" />} label="iCAD" active={activePage === 'icad'} onClick={() => onNavigate('icad')} collapsed={collapsed} data-id="element-6396" data-mp="37xvajwhvio0g" />
        <SidebarItem icon={<BarChart3Icon size={20} data-id="element-6399" data-mp="2yygoracnj1ma" />} label="Admin" active={activePage === 'admin'} onClick={() => onNavigate('admin')} collapsed={collapsed} data-id="element-6398" data-mp="2yxyjxpbxbf2r" />
      </nav>
      {/* User Avatar Menu at bottom */}
      <UserAvatarMenu collapsed={collapsed} onNavigate={onNavigate} activePage={activePage} data-id="element-6400" data-mp="zqry6f75547u" />
      <button onClick={toggleSidebar} className="absolute -right-3 top-1/2 transform -translate-y-1/2 bg-blue-800 text-white p-1.5 rounded-full shadow-lg hover:bg-blue-700 transition-colors opacity-0 group-hover:opacity-100" data-id="element-6401" data-mp="utrozvezvlci">
        {collapsed ? <ChevronRightIcon size={16} data-id="element-6402" data-mp="1iit23vyrvko4" /> : <ChevronLeftIcon size={16} data-id="element-6403" data-mp="1iikqe7edylei" />}
      </button>

      {/* Changelog Modal */}
      {changelogOpen && <div className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={e => {
      if (e.target === e.currentTarget) setChangelogOpen(false);
    }} data-id="element-6404" data-mp="1egfxjavrhssx">
          <div className="bg-[#0f1d3a] rounded-2xl shadow-2xl border border-white/10 w-full max-w-lg max-h-[85vh] flex flex-col overflow-hidden" data-id="element-6405" data-mp="333pensyyo0y">
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 flex-shrink-0" data-id="element-6406" data-mp="3uag5t0m12xft">
              <div data-id="element-6407" data-mp="2epfd8qznrp3j">
                <h2 className="text-white font-semibold text-lg" data-id="element-6408" data-mp="2eow5u47mwj3r">What's New</h2>
                <p className="text-blue-300 text-xs mt-0.5" data-id="element-6409" data-mp="2ir0xixeiv5nr">
                  Version 3.1.0 — April 2026
                </p>
              </div>
              <button onClick={() => setChangelogOpen(false)} className="text-blue-300 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10" data-id="element-6410" data-mp="2niiyvmkgj899">
                <XIcon size={20} data-id="element-6411" data-mp="2xfn9cp4xxfa8" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-6 no-scrollbar" data-id="element-6412" data-mp="2xhzypnd12rxb">
              {/* New Features */}
              <div data-id="element-6413" data-mp="36glejar47sue">
                <div className="flex items-center gap-2 mb-3" data-id="element-6414" data-mp="36h3kiz3kxlfi">
                  <div className="w-7 h-7 rounded-lg bg-emerald-500/20 flex items-center justify-center" data-id="element-6415" data-mp="36e921d44maoq">
                    <SparklesIcon size={14} className="text-emerald-400" data-id="element-6416" data-mp="1c2kisyqv3lyj" />
                  </div>
                  <h3 className="text-white font-semibold text-sm" data-id="element-6417" data-mp="1c4doobtni25h">
                    New Features
                  </h3>
                </div>
                <ul className="space-y-2 ml-9" data-id="element-6418" data-mp="o663km9h3nbr">
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6419" data-mp="o5efdwi7grvi">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-emerald-400 flex-shrink-0" data-id="element-6420" data-mp="120qaw646qmdh"></span>
                    System Settings page with Dealer Information, Design
                    Preferences, and Quote tabs
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6421" data-mp="58weopldphn4">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-emerald-400 flex-shrink-0" data-id="element-6422" data-mp="j7w6250a0amz"></span>
                    Design Preferences: configure default properties for new
                    machine designs
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6423" data-mp="1um9m4nosflsg">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-emerald-400 flex-shrink-0" data-id="element-6424" data-mp="1pozq2p6w8bvn"></span>
                    Business Intelligence dashboard with advanced analytics
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6425" data-mp="2272fahi5sdo1">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-emerald-400 flex-shrink-0" data-id="element-6426" data-mp="1o7kmlr1qsg9e"></span>
                    Dealer mark-up configuration with per-customer override
                    support
                  </li>
                </ul>
              </div>

              {/* Improvements */}
              <div data-id="element-6427" data-mp="2lvb5wn420blf">
                <div className="flex items-center gap-2 mb-3" data-id="element-6428" data-mp="2ltrr70y1q8lr">
                  <div className="w-7 h-7 rounded-lg bg-blue-500/20 flex items-center justify-center" data-id="element-6429" data-mp="2766o371689du">
                    <WrenchIcon size={14} className="text-blue-400" data-id="element-6430" data-mp="2c4qcrf75fz9w" />
                  </div>
                  <h3 className="text-white font-semibold text-sm" data-id="element-6431" data-mp="2zuuf7j8lpszb">
                    Improvements
                  </h3>
                </div>
                <ul className="space-y-2 ml-9" data-id="element-6432" data-mp="34m2o8e60rcby">
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6433" data-mp="3r7meax8lsxso">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-blue-400 flex-shrink-0" data-id="element-6434" data-mp="3r5t7nhxzqdko"></span>
                    Redesigned company information header with distribution
                    country selector
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6435" data-mp="3n5j0w32djj4r">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-blue-400 flex-shrink-0" data-id="element-6436" data-mp="38hehsxzet5lg"></span>
                    Sprinkler section reorganized with separate regulator
                    preferences
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6437" data-mp="2zh9cquhoujag">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-blue-400 flex-shrink-0" data-id="element-6438" data-mp="33hjsuzz72q31"></span>
                    Billing country moved to Billing Address tab for better data
                    organization
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6439" data-mp="2ugtym0pl17rf">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-blue-400 flex-shrink-0" data-id="element-6440" data-mp="2awmng0pxi19c"></span>
                    Improved sidebar navigation with version tracking
                  </li>
                </ul>
              </div>

              {/* Bug Fixes */}
              <div data-id="element-6441" data-mp="2fuob6yyauor5">
                <div className="flex items-center gap-2 mb-3" data-id="element-6442" data-mp="2fues7vbo9huy">
                  <div className="w-7 h-7 rounded-lg bg-amber-500/20 flex items-center justify-center" data-id="element-6443" data-mp="2fx0ylrmttrbl">
                    <BugIcon size={14} className="text-amber-400" data-id="element-6444" data-mp="2ovcn9o44uf1e" />
                  </div>
                  <h3 className="text-white font-semibold text-sm" data-id="element-6445" data-mp="2otiawy6xfv8x">
                    Bug Fixes
                  </h3>
                </div>
                <ul className="space-y-2 ml-9" data-id="element-6446" data-mp="2ykw6iuvrcaws">
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6447" data-mp="2yn8vvt3uhnjv">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-amber-400 flex-shrink-0" data-id="element-6448" data-mp="3cl6yy2cptxk2"></span>
                    Fixed logo upload preview not updating correctly on first
                    upload
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6449" data-mp="3klmp8d8vby4z">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-amber-400 flex-shrink-0" data-id="element-6450" data-mp="3kjiou5a6hh9g"></span>
                    Resolved dropdown styling inconsistencies in dark mode
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6451" data-mp="3udizemo8bepk">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-amber-400 flex-shrink-0" data-id="element-6452" data-mp="274437bniypm"></span>
                    Fixed quote calculation rounding errors on certain mark-up
                    values
                  </li>
                </ul>
              </div>

              {/* Community Contributors */}
              <div data-id="element-6453" data-mp="h2tqh6kr1duv">
                <div className="flex items-center gap-2 mb-3" data-id="element-6454" data-mp="2dx6d8mclesjg">
                  <div className="w-7 h-7 rounded-lg bg-pink-500/20 flex items-center justify-center" data-id="element-6455" data-mp="2dyra4imdqnkh">
                    <HeartIcon size={14} className="text-pink-400" data-id="element-6456" data-mp="2iwj89udmb5x4" />
                  </div>
                  <h3 className="text-white font-semibold text-sm" data-id="element-6457" data-mp="102ptjy4habva">
                    Community Contributors
                  </h3>
                </div>
                <p className="text-xs text-blue-300/60 ml-9 mb-3" data-id="element-6458" data-mp="r8bgm27f7dfc">
                  Thanks to the users who shared feedback and helped shape this
                  release.
                </p>
                <div className="ml-9 space-y-2.5" data-id="element-6459" data-mp="1izr4s0oml87o">
                  <div className="flex items-center gap-2.5" data-id="element-6460" data-mp="1iz7vf8d1js59">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center flex-shrink-0" data-id="element-6461" data-mp="1ey5umn3h7816">
                      <span className="text-[10px] font-bold text-white" data-id="element-6462" data-mp="1a15n07qz9x7y">
                        MR
                      </span>
                    </div>
                    <div data-id="element-6463" data-mp="3uql6sirs4lo3">
                      <span className="text-sm text-white font-medium" data-id="element-6464" data-mp="3uqv28lvlfl16">
                        Miguel Rodríguez
                      </span>
                      <span className="text-xs text-blue-300/60 ml-2" data-id="element-6465" data-mp="1hi0stvu0xv7i">
                        — Sprinkler section reorganization
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2.5" data-id="element-6466" data-mp="18hm5kqxi261d">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-blue-400 to-indigo-500 flex items-center justify-center flex-shrink-0" data-id="element-6467" data-mp="18ezr07c6yq9n">
                      <span className="text-[10px] font-bold text-white" data-id="element-6468" data-mp="216t3pot1ktm3">
                        AK
                      </span>
                    </div>
                    <div data-id="element-6469" data-mp="2550iie3y3kun">
                      <span className="text-sm text-white font-medium" data-id="element-6470" data-mp="1r83lfux8h75b">
                        Anna Kovalenko
                      </span>
                      <span className="text-xs text-blue-300/60 ml-2" data-id="element-6471" data-mp="1w53tuchk2lzl">
                        — Billing address improvements
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2.5" data-id="element-6472" data-mp="kst64kho5g20">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-purple-400 to-pink-500 flex items-center justify-center flex-shrink-0" data-id="element-6473" data-mp="d77h4kqvnj32">
                      <span className="text-[10px] font-bold text-white" data-id="element-6474" data-mp="8b8nahms58v9">
                        JL
                      </span>
                    </div>
                    <div data-id="element-6475" data-mp="handdfz1bhf8">
                      <span className="text-sm text-white font-medium" data-id="element-6476" data-mp="hadjhhavcq49">
                        José López
                      </span>
                      <span className="text-xs text-blue-300/60 ml-2" data-id="element-6477" data-mp="3lo2a98hvhp3y">
                        — Quote mark-up per customer feature
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-6 py-3 border-t border-white/10 flex-shrink-0 bg-black/20" data-id="element-6478" data-mp="3un5r05tkhsfa">
              <p className="text-xs text-blue-300/50 text-center" data-id="element-6479" data-mp="36x35y9o2lmq6">
                Have feedback? Let us know through Customer Support
              </p>
            </div>
          </div>
        </div>}
    </div>;
}
function UserAvatarMenu({
  collapsed,
  onNavigate,
  activePage
}) {
  const {
    role: userRole,
    name: userName,
    email: userEmail
  } = useUser();
  const [isOpen, setIsOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [unitsOpen, setUnitsOpen] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[1]); // Spanish default
  const [selectedUnit, setSelectedUnit] = useState(unitSystems[0]); // Metric default
  const menuRef = useRef<HTMLDivElement>(null);
  // Determine if company info should be read-only based on role
  const isReadOnly = userRole === 'dealer' || userRole === 'customer' || userRole === 'authenticated-public-user';
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
        setLanguageOpen(false);
        setUnitsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      setLanguageOpen(false);
      setUnitsOpen(false);
    }
  };
  const handleSelectLanguage = (lang: (typeof languages)[0]) => {
    setSelectedLanguage(lang);
    setLanguageOpen(false);
  };
  const handleSelectUnit = (unit: (typeof unitSystems)[0]) => {
    setSelectedUnit(unit);
    setUnitsOpen(false);
  };
  return <>
      <div className="relative px-3 py-4 mt-auto border-t border-blue-800/30" ref={menuRef} data-id="element-6480" data-mp="306llt9yvmvzx">
        {/* Avatar trigger */}
        <button onClick={handleToggle} className={`w-full flex items-center rounded-lg px-2 py-2 transition-colors hover:bg-white/10 ${isOpen ? 'bg-white/10' : ''} ${collapsed ? 'justify-center' : ''}`} aria-label="User menu" aria-expanded={isOpen} aria-haspopup="true" data-id="element-6481" data-mp="ydf7ixuwvps6">
          <div className="relative flex-shrink-0" data-id="element-6482" data-mp="c8z5j7q4g90j">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center ring-2 ring-blue-400/30 shadow-lg" data-id="element-6483" data-mp="3to5woikbcf3w">
              <span className="text-sm font-bold text-white" data-id="element-6484" data-mp="3kmpqkn0j6z5h">DA</span>
            </div>
            <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-400 rounded-full border-2 border-blue-950" data-id="element-6485" data-mp="3kp2gpngg0ftm" />
          </div>
          {!collapsed && <div className="ml-3 flex-1 text-left min-w-0" data-id="element-6486" data-mp="3apjvl3osqnzz">
              <p className="text-sm font-semibold text-white truncate leading-tight" data-id="element-6487" data-mp="3fnd3c15qzq2d">
                {userName}
              </p>
              <p className="text-xs text-blue-300 truncate leading-tight" data-id="element-6488" data-mp="18y6ukppy9097">
                {userRole.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
              </p>
            </div>}
          {!collapsed && <ChevronUpIcon size={16} className={`text-blue-300 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-6489" data-mp="2yek7yte8fhe8" />}
        </button>

        {/* Popover Menu — opens to the right of the sidebar */}
        {isOpen && <div className="absolute bottom-0 left-full ml-2 w-72 bg-[#0f1d3a] rounded-xl shadow-2xl border border-white/10 z-[100] overflow-hidden" data-id="element-6490" data-mp="33dngwoxc27rh">
            {/* User Info Header */}
            <div className="px-4 pt-4 pb-3 border-b border-white/10" data-id="element-6491" data-mp="3h6ldufpfc7x5">
              <div className="flex items-start" data-id="element-6492" data-mp="3c5flwk3l8ooo">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center ring-2 ring-blue-400/20 flex-shrink-0" data-id="element-6493" data-mp="3r3hsl35x1qa5">
                  <span className="text-base font-bold text-white" data-id="element-6494" data-mp="3m20oyzw1rppv">DA</span>
                </div>
                <div className="ml-3 min-w-0 flex-1" data-id="element-6495" data-mp="1wqrv6bgc9yy0">
                  <p className="text-sm font-semibold text-white truncate" data-id="element-6496" data-mp="1rr5ji6g5sqrb">
                    {userName}
                  </p>
                  <p className="text-xs text-blue-300 truncate" data-id="element-6497" data-mp="3kt2yneac80jp">{userEmail}</p>
                  <span className="inline-flex items-center mt-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-teal-500/20 text-teal-300 border border-teal-500/30" data-id="element-6498" data-mp="3fvjk0d9q9lr8">
                    {userRole.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                  </span>
                </div>
                <button className="p-1.5 rounded-lg hover:bg-white/10 transition-colors text-blue-400 hover:text-white flex-shrink-0 mt-0.5" onClick={() => {
              setIsOpen(false);
              setProfileModalOpen(true);
            }} title="Edit profile" data-id="element-6499" data-mp="31y4qawcfyrtg">
                  <PencilIcon size={14} data-id="element-6500" data-mp="36ttigem4t6fq" />
                </button>
              </div>
            </div>

            {/* Company Info */}
            <div className="px-4 py-3 border-b border-white/10" data-id="element-6501" data-mp="r636799cgdix">
              <div className="flex items-center justify-between" data-id="element-6502" data-mp="m4nkrg398500">
                <div className="flex items-center min-w-0" data-id="element-6503" data-mp="tof0iys4zyap">
                  <div className="w-8 h-8 rounded-lg bg-blue-600/20 flex items-center justify-center flex-shrink-0" data-id="element-6504" data-mp="tr182yf12dsx">
                    <BuildingIcon size={16} className="text-blue-400" data-id="element-6505" data-mp="ko9v2u6i79z6" />
                  </div>
                  <div className="ml-2.5 min-w-0" data-id="element-6506" data-mp="opbvvfg2ju39">
                    <p className="text-xs text-blue-400 leading-tight" data-id="element-6507" data-mp="oq3qoo1udnsh">
                      Company
                    </p>
                    <p className="text-sm font-semibold text-white truncate leading-tight" data-id="element-6508" data-mp="1chilzwv7b4u8">
                      ZEPPELIN
                    </p>
                  </div>
                </div>
                <button className="p-1.5 rounded-lg hover:bg-white/10 transition-colors text-blue-400 hover:text-white flex-shrink-0" onClick={() => {
              setIsOpen(false);
              setCompanyModalOpen(true);
            }} title="Edit company" data-id="element-6509" data-mp="13krvdzzf4i71">
                  <PencilIcon size={14} data-id="element-6510" data-mp="205sd9eb6oksr" />
                </button>
              </div>
            </div>

            {/* Menu Items */}
            <div className="py-1.5" data-id="element-6511" data-mp="29ymw6ll4mz4a">
              {/* Language Selector */}
              <div className="relative" data-id="element-6512" data-mp="25znioclbxu18">
                <button className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => {
              setLanguageOpen(!languageOpen);
              setUnitsOpen(false);
            }} data-id="element-6513" data-mp="2102jq265tloi">
                  <div className="flex items-center" data-id="element-6514" data-mp="1r3fyvddu2umh">
                    <GlobeIcon size={16} className="mr-3 text-blue-400 flex-shrink-0" data-id="element-6515" data-mp="1mamvoty0juci" />
                    Language
                  </div>
                  <div className="flex items-center" data-id="element-6516" data-mp="1ia2xdn1pekos">
                    <span className="text-xs text-blue-300 mr-1.5" data-id="element-6517" data-mp="1daq9cyz3j7km">
                      {selectedLanguage.flag} {selectedLanguage.name}
                    </span>
                    <ChevronRightIconSmall open={languageOpen} data-id="element-6518" data-mp="18dhqsxa1d1iu" />
                  </div>
                </button>
                {languageOpen && <div className="mx-2 mb-1 rounded-lg bg-white/5 border border-white/10 overflow-hidden" data-id="element-6519" data-mp="t8m0pl7kmt1a">
                    {languages.map(lang => <button key={lang.code} className="w-full flex items-center px-4 py-2 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => handleSelectLanguage(lang)} data-id="element-6520" data-mp="y6f98kwcjz4q">
                        <span className="mr-2.5 text-base" data-id="element-6521" data-mp="184l9ky2i8x7h">{lang.flag}</span>
                        <span className="flex-1 text-left" data-id="element-6522" data-mp="aie3fjqjywt0">{lang.name}</span>
                        {selectedLanguage.code === lang.code && <CheckIcon size={14} className="text-teal-400 flex-shrink-0" data-id="element-6523" data-mp="fi0hfve7gh2v" />}
                      </button>)}
                  </div>}
              </div>

              {/* Unit System Selector */}
              <div className="relative" data-id="element-6524" data-mp="p7tr2qusem4h">
                <button className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => {
              setUnitsOpen(!unitsOpen);
              setLanguageOpen(false);
            }} data-id="element-6525" data-mp="p8v4v336tmpw">
                  <div className="flex items-center" data-id="element-6526" data-mp="1ygolumvd0xke">
                    <RulerIcon size={16} className="mr-3 text-blue-400 flex-shrink-0" data-id="element-6527" data-mp="1tgk5qxyd64up" />
                    Units
                  </div>
                  <div className="flex items-center" data-id="element-6528" data-mp="286hxtozezep6">
                    <span className="text-xs text-blue-300 mr-1.5" data-id="element-6529" data-mp="2879l8ciuy64d">
                      {selectedUnit.name}
                    </span>
                    <ChevronRightIconSmall open={unitsOpen} data-id="element-6530" data-mp="2h5d38yumwkrf" />
                  </div>
                </button>
                {unitsOpen && <div className="mx-2 mb-1 rounded-lg bg-white/5 border border-white/10 overflow-hidden" data-id="element-6531" data-mp="2d3rmh2ezbmby">
                    {unitSystems.map(unit => <button key={unit.id} className="w-full flex items-center px-4 py-2.5 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => handleSelectUnit(unit)} data-id="element-6532" data-mp="2r1ybdt1yabzh">
                        <div className="flex-1 text-left" data-id="element-6533" data-mp="wsdvnvioak91">
                          <span data-id="element-6534" data-mp="rs892tr9fnxt">{unit.name}</span>
                          <span className="ml-2 text-xs text-blue-400" data-id="element-6535" data-mp="rtj9qkpesfkp">
                            {unit.id === 'metric' ? 'm, ha, l/s' : 'ft, acre, GPM'}
                          </span>
                        </div>
                        {selectedUnit.id === unit.id && <CheckIcon size={14} className="text-teal-400 flex-shrink-0" data-id="element-6536" data-mp="2tnp5le5uiz83" />}
                      </button>)}
                  </div>}
              </div>

              <div className="my-1 mx-3 border-t border-white/10" data-id="element-6537" data-mp="2kobwwnpjqeof" />

              {/* Settings */}
              <button className="w-full flex items-center px-4 py-2.5 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => {
            setIsOpen(false);
            onNavigate('settings');
          }} data-id="element-6538" data-mp="2pmvkstnpa0jf">
                <SettingsIcon size={16} className="mr-3 text-blue-400 flex-shrink-0" data-id="element-6539" data-mp="2fo64347jim4r" />
                Settings
              </button>

              {/* Sign Out */}
              <button className="w-full flex items-center px-4 py-2.5 text-sm text-red-300 hover:bg-red-500/10 transition-colors" onClick={() => {
            setIsOpen(false);
          }} data-id="element-6540" data-mp="dxm5jf0md1qb">
                <LogOutIcon size={16} className="mr-3 text-red-400 flex-shrink-0" data-id="element-6541" data-mp="ce2sbiaw1cvv" />
                Sign out
              </button>
            </div>
          </div>}
      </div>

      <EditProfileModal isOpen={profileModalOpen} onClose={() => setProfileModalOpen(false)} data-id="element-6542" data-mp="2ij5rmi7rqjs" />
      <EditCompanyModal isOpen={companyModalOpen} onClose={() => setCompanyModalOpen(false)} readOnly={isReadOnly} data-id="element-6543" data-mp="3unv4qeep9bwf" />
    </>;
}
function ChevronRightIconSmall({
  open
}: {
  open: boolean;
}) {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`text-blue-400 transition-transform duration-200 ${open ? 'rotate-90' : ''}`} data-id="element-6544" data-mp="q8dg9xf2930v">
      <polyline points="9 18 15 12 9 6" data-id="element-6545" data-mp="1dxen5g88w641" />
    </svg>;
}
function SidebarItem({
  icon,
  label,
  active = false,
  onClick,
  collapsed
}) {
  return <div className={`flex items-center px-3 py-2 my-1 rounded ${active ? 'bg-blue-800' : 'hover:bg-blue-800/50'} cursor-pointer transition-colors ${collapsed ? 'justify-center' : ''}`} onClick={onClick} title={collapsed ? label : ''} data-id="element-6546" data-mp="195wk8mmnvvgf">
      <div className={`${collapsed ? '' : 'mr-3'} text-gray-300 flex-shrink-0`} data-id="element-6547" data-mp="2wudpenad7tzh">
        {icon}
      </div>
      {!collapsed && <span className="text-sm whitespace-nowrap truncate" data-id="element-6548" data-mp="35sz5mbsd6wx3">{label}</span>}
    </div>;
}
// Add custom CSS to hide scrollbar but maintain functionality
const style = document.createElement('style');
style.textContent = `
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;
document.head.appendChild(style);